import React from 'react';

function SearchFundResults(props) {
  const { funds, selected, onFundToggle } = props;

  return (
    <div className="FundSearchResult">
      <h3>
        Display {funds.length} most relevant result
        {funds.length > 1 && 's'} found:
      </h3>
      <ul className="FundList">
        {funds.map(fund => {
          const checked =
            selected.map(selectedFund => selectedFund.usi).indexOf(fund.usi) >
            -1;

          return (
            <li key={fund.usi}>
              <input
                type="checkbox"
                name={fund.usi}
                id={fund.usi}
                checked={checked}
                onChange={onFundToggle}
              />
              <label htmlFor={fund.usi}>
                {fund.productName} (USI: {fund.usi})
              </label>
            </li>
          );
        })}
      </ul>
      <p>
        If you cannot see what you're looking for, try searching for a more
        specific name, or the fund's USI or ABN.
      </p>
    </div>
  );
}

export default SearchFundResults;
